<template>
  <div style="width: 600px;margin: 0 auto;margin-top: 100px;margin-bottom: 100px">
    <p style="text-align: center;font-size: 22px;font-weight: bold">企业注册</p>
     <el-form :model="form" status-icon :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
  <el-form-item label="手机号码" prop="username">
    <el-input maxlength="11" v-model="form.username"></el-input>
  </el-form-item>
   <el-form-item label="密码" prop="password">
    <el-input  maxlength="8" type="password" v-model="form.password"></el-input>
  </el-form-item>
       <el-form-item label="确认密码" prop="agpassword">
    <el-input type="password" maxlength="8" v-model="form.agpassword"></el-input>
  </el-form-item>
       <el-form-item label="手机验证码" prop="code">
    <el-input type="code" maxlength="4" v-model="form.code"></el-input>
         <el-form-item style="float: right">
           <span v-show="show" > <el-button @click="getCheckNum()" >获取验证码</el-button></span>
            <span v-show="!show" class="count"><el-button   >请稍后在次发送{{count}} s</el-button></span>
        </el-form-item>
  </el-form-item>
  <el-form-item>
    <el-button type="primary" @click="submitForm" style="width:100%">确认</el-button>
      <router-link to='/' class="sidebar-nav-link"><el-button type="primary" style="width:100%;margin-left: 0px;margin-top: 5px">取消</el-button> </router-link>
  </el-form-item>

</el-form>
  </div>
</template>

<script>
import rootPathssb from '@/api/mainApi'
import { dataPost } from '@/api/index'
export default {
  name: 'enterprisereg',
  data () {
    var checkPhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('手机号不能为空'))
      } else {
        const reg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/
        console.log(reg.test(value))
        if (reg.test(value)) {
          callback()
        } else {
          return callback(new Error('请输入正确的手机号'))
        }
      }
    }
    var checkAgpassword = (rule, value, callback) => {
      let that = this
      if (!value) {
        callback(new Error('请再次输入密码'))
      } else if (value !== that.form.password) {
        callback(new Error('请确认两次密码一致'))
      } else {
        callback()
      }
    }

    return {
      show: true,
      count: '',
      timer: null,
      msg: {checkmobilenumMsg: ''},
      form: {
        username: '',
        password: '',
        agpassword: '',
        code: ''

      },
      rules: {
        username: [
          {required: true, validator: checkPhone, trigger: 'blur'},
          { min: 11, max: 11, message: '请输入12位', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '密码不能为空', trigger: 'blur' },
          { min: 8, max: 8, message: '请输入8位密码', trigger: 'blur' }
        ],
        agpassword: [
          { required: true, message: '请再次输入密码', trigger: 'blur' },
          { min: 8, max: 8, trigger: ['blur', 'change'], validator: checkAgpassword }
        ],
        code: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
          { min: 4, max: 4, message: '请输入4位正确验证码', trigger: 'blur' }

        ]
      }
    }
  },
  methods: {
    submitForm (event) {
      var params = new URLSearchParams()
      let that = this
      if (that.form.username === '') { alert('请输入手机号') } else if (that.form.password === '') { alert('请输入密码') } else if (that.form.agpassword !== that.form.password) { alert('请确认两次密码一致') } else if (that.form.code === '') { alert('请输入验证码') } else {
        params.append('username', this.form.username)
        params.append('password', this.form.password)
        params.append('agpassword', this.form.agpassword)
        params.append('code', this.form.code)
        dataPost(rootPathssb.rootPath + '/us/reg', params).then(function (response) {
          if (response.data.result === 0) {};
          if (response.data.result === 1) {
            alert('注册成功')
            that.$router.push({path: '/'})
            console.log('cg')
          };console.log(response.data)
        }).catch(function (error) {
          console.log(error); console.log(2222222222)
        })
      }
    },
    getCheckNum () {
      var params = new URLSearchParams()
      let that = this
      let reg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/
      params.append('mobile', that.form.username)
      // eslint-disable-next-line no-unused-expressions
      if (that.form.username === '') { alert('请输入手机号') } else if (!reg.test(that.form.username)) { '请输入正确手机好' } else {
        that.getCode()
        dataPost(rootPathssb.rootPath + '/sendcode', params).then(function (response) {
          that.msg.checkmobilenumMsg = response.data.msg
          console.log(response.data)
        }).catch(function (error) {
          console.log(error); console.log(2222222222)
        })
      }
    }, // 获取验证码
    getCode () {
      const TIME_COUNT = 60
      if (!this.timer) {
        this.count = TIME_COUNT

        this.show = false

        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--
          } else {
            this.show = true

            clearInterval(this.timer)

            this.timer = null
          }
        }, 1000)
      }
    } // 验证码延时

  }

}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/computer/enterprisereg.vue